export default __webpack_public_path__ + "static/media/Rolls_Royce.1b3ac248.png";